function runWhenJQueryIsLoaded(callback) {
	try {
		if (window.jQuery) {
			// jQuery is loaded, run the callback
			callback(jQuery);
		} else {
			// jQuery is not loaded, wait for 100ms and try again
			setTimeout(function() {
				runWhenJQueryIsLoaded(callback);
			}, 100);
		}
	} catch (error) {
		console.error("Error running when jQuery is loaded:", error);
	}
}

runWhenJQueryIsLoaded(function($) {

	console.info("JQUERY", jQuery().jquery);

	function request(callback){
		$.getJSON("/search/suggest.json", {
			"q": searched,
			"resources": {
				"type": "product,article,page",
				"limit": 8,
				"options": {
					"unavailable_products": "last",
					"fields": "title,product_type,variants.title,variants.barcode,variants.sku,tag"
				}
			}
		}).done(function(response) {
			if(callback)
				callback(response);
		});
	}

	function closeSuggest(removeCtn){
		if(removeCtn)
			$(".ctn_search_predict").fadeOut(300).html("");
		else
			$(".ctn_search_predict").fadeOut(300);
	}

	function showSuggest(){
		if($(".ctn_search_predict").css("display") === "none")
			$(".ctn_search_predict").fadeIn(300);
	}


	function searchTrigger(){
		if(searched === searchedOld && searched){
			if(searched){
				console.info('updated Search result');

				request(function(res){
					showSuggest();

					var listRes = {
						"product": 	res.resources.results.products || [],
						"page": 	res.resources.results.pages || [],
						"article": 	res.resources.results.articles || []
					};

					var outputHtml = '';
					for (const key in listRes) {
						if (listRes.hasOwnProperty(key) && listRes[key].length > 0) {
							const objList = listRes[key];

							outputHtml += '<div class="section_search_predict">' + 
								'<h3 class="title_search_predict">' + key[0].toUpperCase() + key.substr(1) + '</h3><ul>';
							for (let i = 0; i < objList.length; i++) {
								const data = objList[i];
								outputHtml += '<li>' +
									'<a class="flex alignCenter" href="'+data.url+'">' + 
									(key === 'product'? '<div class="flex alignCenter img_ctn_search_result">' + 
										'<img src="' + data.image + '"/>' + 
									'</div>': '') + 
									'<span>' + data.title + '</span>'
								'</a></li>';
							}
							outputHtml += '</ul></div>';
						}
					}

					$(".ctn_search_predict").html(outputHtml);

					console.info('RES', res);
				})
			}else{
				closeSuggest(true);
				searchResult = [];
			}
		}
	}

	function req(args, callback, failCallback){
		let url = "https://api.ehub.work/task_multi";
		/* if(window.grecaptcha){
			window.grecaptcha.ready(function() {
				let actionName = "recapForceName" in args? args.recapForceName : `${args.api}/${args.trigger}`;
				
				window.grecaptcha.execute("6LdMEKoaAAAAADQDFdOk3F3HC8F9ZjT7eXe6iGiq", {action: actionName}).then(function(token) {
					
					args.token = token;

					$.post(url, Object.assign({
						"token": token,
					}, args)).done(callback).fail(failCallback? failCallback : function(jqXHR, textStatus, errorThrown) {
						alert( "Error:" + textStatus );
						console.warn( textStatus );
					})
				});
			});
		}else{
			if(failCallback)	failCallback("Tken not found");
		} */
		if(grecaptcha){
			grecaptcha.enterprise.ready(function() {
				let actionName = "recapForceName" in args? args.recapForceName : `${args.api}/${args.trigger}`;
				
				grecaptcha.enterprise.execute("6Ld5cM4dAAAAAIR103Fx78hXh9Omssru3RTzABs0", {action: `haus_${actionName}`}).then(function(token) {
					
					args.token = token;

					$.post(url, Object.assign({
						"token": token,
					}, args)).done(callback).fail(failCallback? failCallback : function(jqXHR, textStatus, errorThrown) {
						alert( "Error:" + textStatus );
						console.warn( textStatus );
					})
				});
			});
		}else{
			if(failCallback)	failCallback("Token not found");
		}
	}

		console.info("TTTTESTS", $);

		// $(function() {

			/* (function(){
				$(".ctnDescription .product-specifications").each(function(index, node){
					let newctnVal = '<div class="attribute-group">' + 
									$(node).find(".attribute-group-name").get(0).outerHTML;
					$( node ).find(".attribute").each(function(index2, node2){
						newctnVal += '<div class="clearfix attribute-row">';
						newctnVal += $(node2).get(0).outerHTML;
						newctnVal += $(node2).next().get(0).outerHTML;
						newctnVal += '</div>';
					});
					newctnVal += '</div>';
					
					$(node).html(newctnVal);
				})
				$(".ctnDescription").append('<div class="clearBoth"></div>')
			})(); */

			(function(){
				var cycleLimitDataset = 500;
				var clIntDt = setInterval(() => {
					// Safety check: ensure jQuery is available
					if (!$) {
						cycleLimitDataset--;
						if (cycleLimitDataset === 0) {
							console.warn('hausOfTools: jQuery not available, stopping dataset processing');
							clearInterval(clIntDt);
						}
						return;
					}

					// Check if we've reached the cycle limit
					if (cycleLimitDataset === 0) {
						console.warn('hausOfTools: Cycle limit reached for dataset processing');
						clearInterval(clIntDt);
						return;
					}

					var hasCtnProductLine = $(".ctnProductLine").length > 0;
					var hasProductSpecs = $(".product-specifications").length > 0;
					var hasClearBoth = $(".clearBoth").length > 0;

					// If container exists but no specs to process and already processed, exit
					if (hasCtnProductLine && !hasProductSpecs && hasClearBoth) {
						clearInterval(clIntDt);
						return;
					}

					// If container exists but no specs to process (and not processed yet), exit
					if (hasCtnProductLine && !hasProductSpecs && !hasClearBoth) {
						clearInterval(clIntDt);
						return;
					}

					// If we have product specs and haven't processed them yet, process them
					if (hasProductSpecs && !hasClearBoth && hasCtnProductLine) {
						try {
							$(".ctnDescription .product-specifications:not(.ctn-files-specifications)").each(function(index, node){
								let newctnVal = '<div class="attribute-group">';
								
								if($(node).find(".attribute-group-name").get(0)){
									newctnVal += $(node).find(".attribute-group-name").get(0).outerHTML;
								}
								$( node ).find(".attribute").each(function(index2, node2){
									newctnVal += '<div class="clearfix attribute-row">';
									newctnVal += $(node2).get(0).outerHTML;
									if ($(node2).next().length > 0) {
										newctnVal += $(node2).next().get(0).outerHTML;
									}
									newctnVal += '</div>';
								});
								newctnVal += '</div>';
								
								$(node).html(newctnVal);
							});
							
							$(".ctnDescription").append('<div class="clearBoth"></div>');
							
							// Initialize masonry if available
							if ($.fn.masonry) {
								$('.ctnDescription').masonry({
									itemSelector: '.product-specifications',
									percentPosition: true
								});
							}
							
							clearInterval(clIntDt);
						} catch (error) {
							console.error('hausOfTools: Error processing product specifications:', error);
							clearInterval(clIntDt);
						}
						return;
					}

					// Decrement counter and continue waiting
					cycleLimitDataset--;
				}, 50);
			})();
			
			(function(){
				var cycleLimitBtnPay = 100;
				var clInt = setInterval(() => {
					if(cycleLimitBtnPay === 0 || $(".page-content--product").length === 0){
						clearInterval(clInt);
					}else cycleLimitBtnPay--;
					if($(".shopify-payment-button__button").length > 0 && !$(".shopify-payment-button__button").hasClass("btn")){
						$(".shopify-payment-button__button").addClass("btn").addClass("btn--full");
						$(".shopify-cleanslate > div").each((i, node) => {
							$(node).attr("style", "background-color: #000000 !important; color: #FFFFFF !important; border: none !important;")
						})
					}
				}, 40);
			})();

			/* (function(){
				var cycleLimitBtnPay = 100;
				var clInt = setInterval(() => {
					if(cycleLimitBtnPay === 0 || document.querySelectorAll(".page-content--product").length === 0){
						clearInterval(clInt);
					}else cycleLimitBtnPay--;
					var paymentButton = document.querySelector(".shopify-payment-button__button");
					if(paymentButton && !paymentButton.classList.contains("btn")){
						paymentButton.classList.add("btn", "btn--full");
						var divs = document.querySelectorAll(".shopify-cleanslate > div");
						divs.forEach((node) => {
							node.style.backgroundColor = "#000000";
							node.style.color = "#FFFFFF";
							node.style.border = "none";
						})
					}
				}, 40);
			})(); */
			
			
			/* (function(){
				var ctnVote = $(".ctn_vote"),
					token = "3dc11e94a05d69227f11b3a704328ece0b958c30d1c992b01880ff3ef282a2b6",
					url = "https://api.ehub.work/shopify";
			
				if(ctnVote && 1==2){
			
					var idProduct = $(".ctn_vote").attr("data-idProduct")
			
					if(idProduct){
			
						$.post(url, {
							"token": token,
							"api": "shopify",
							"trigger": "hasVoted",
							"id_product": idProduct
						},
						function(rVoted){
							console.log("Result: ", rVoted);
							
							if(rVoted.success && !rVoted.res){
								ctnVote.fadeIn();
								
								$.post(url, {
									"token": token,
									"api": "shopify",
									"trigger": "fetchTagsGroup",
									"shop": "hausoftools",
									"grpName": "Trade"
								},
								function(rTradeList){
									console.log("Result: ", rTradeList);
			
									if(rTradeList.success && rTradeList.res){
										let strTrades = '';
										$(rTradeList.res.data).each(function(i, trade){
											strTrades += '<option value="' + trade.id + '">' + trade.name + '</option>';
										});
										$("#listTrade").html( strTrades );
									}
								});
			
			
							}
						});
			
						$("#form_trade_vote").on("submit", function(e){
							e.preventDefault();
			
							$("#sbtn_vote").attr("disabled", true);
			
							var idTrade = $("#listTrade").val();
				
							console.log("list", $("#listTrade").val());
							console.log("id_item", idProduct);
			
							$.post(url, {
								"token": token,
								"api": "shopify",
								"trigger": "addRelationTagItem",
								"id_product": idProduct,
								"id_tag": idTrade
							},
							function(rTradeList){
								console.log("Result: ", rTradeList);
			
								if(rTradeList.success && rTradeList.res.processed){
									var seconde = 5;
									$(".body_vote").html($(".lineSuccess").html())
									var nodeTime = $(".timeBeforeClosing");
									nodeTime.html(seconde);
			
									var intTime = setInterval(function(){
										seconde--;
										if(seconde === 1){
											clearInterval(intTime);
											ctnVote.slideUp();
										}
										nodeTime.html(seconde);
									}, 1000)
								}else{
									ctnVote.slideUp();
								}
							});
							
						});
			
					}
			
					$(".title_vote").on("click", function(e){
						$(".body_vote").slideToggle(300);
					});
				}
			})(); */

			(function(){
				var ctnVote = document.querySelector(".ctn_vote"),
					token = "3dc11e94a05d69227f11b3a704328ece0b958c30d1c992b01880ff3ef282a2b6",
					url = "https://api.ehub.work/shopify";
			
				if(ctnVote && 1==2){
			
					var idProduct = ctnVote.getAttribute("data-idProduct")
			
					if(idProduct){
			
						fetch(url, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify({
								"token": token,
								"api": "shopify",
								"trigger": "hasVoted",
								"id_product": idProduct
							}),
						})
						.then(response => response.json())
						.then(rVoted => {
							console.log("Result: ", rVoted);
			
							if(rVoted.success && !rVoted.res){
								ctnVote.style.display = 'block';
			
								fetch(url, {
									method: 'POST',
									headers: {
										'Content-Type': 'application/json',
									},
									body: JSON.stringify({
										"token": token,
										"api": "shopify",
										"trigger": "fetchTagsGroup",
										"shop": "hausoftools",
										"grpName": "Trade"
									}),
								})
								.then(response => response.json())
								.then(rTradeList => {
									console.log("Result: ", rTradeList);
			
									if(rTradeList.success && rTradeList.res){
										let strTrades = '';
										rTradeList.res.data.forEach((trade) => {
											strTrades += '<option value="' + trade.id + '">' + trade.name + '</option>';
										});
										document.querySelector("#listTrade").innerHTML = strTrades;
									}
								});
							}
						});
			
						document.querySelector("#form_trade_vote").addEventListener("submit", function(e){
							e.preventDefault();
			
							document.querySelector("#sbtn_vote").setAttribute("disabled", true);
			
							var idTrade = document.querySelector("#listTrade").value;
			
							console.log("list", document.querySelector("#listTrade").value);
							console.log("id_item", idProduct);
			
							fetch(url, {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json',
								},
								body: JSON.stringify({
									"token": token,
									"api": "shopify",
									"trigger": "addRelationTagItem",
									"id_product": idProduct,
									"id_tag": idTrade
								}),
							})
							.then(response => response.json())
							.then(rTradeList => {
								console.log("Result: ", rTradeList);
			
								if(rTradeList.success && rTradeList.res.processed){
									var seconde = 5;
									document.querySelector(".body_vote").innerHTML = document.querySelector(".lineSuccess").innerHTML;
									var nodeTime = document.querySelector(".timeBeforeClosing");
									nodeTime.innerHTML = seconde;
			
									var intTime = setInterval(function(){
										seconde--;
										if(seconde === 1){
											clearInterval(intTime);
											ctnVote.style.display = 'none';
										}
										nodeTime.innerHTML = seconde;
									}, 1000)
								}else{
									ctnVote.style.display = 'none';
								}
							});
			
						});
			
					}
			
					document.querySelector(".title_vote").addEventListener("click", function(e){
						var bodyVote = document.querySelector(".body_vote");
						bodyVote.style.display = bodyVote.style.display === 'none' ? 'block' : 'none';
					});
				}
			})();
			
			
			/* (function(){
				var searched = "",
					searchedOld = "",
					searchResult = [];
			
				$(".site-header__search-input").on("keyup", function(e){
					console.log("Search update:", $(e.target).val());
					
					var valChearched = $(e.target).val();
			
					console.log(valChearched.trim().length);
					
					if(valChearched.trim().length === 0){
						closeSuggest(true);
						searched = "",
						searchedOld = "",
						searchResult = []
					}else if(valChearched.length >= 2){
						searchedOld = valChearched
				
						var timer = setTimeout(() => {
							searched = valChearched;
							searchTrigger();
							clearTimeout(timer);
						}, 500)
					}
				});
			
				$(".js-search-header-close, #MainContent").on("click", function(e){
					closeSuggest();
				});
			
				$(".js-search-header").on("click", function(e){
					showSuggest();
				});
			
			})(); */

			/* (function(){
				$(".btnEditAccount").click(e => {
					$("#formEditUserData").addClass("editMode")
					$("#checkboxMarketing").attr("disabled", false)
				})

				$(".btnSubmitCloseEdit").click(e => {
					$("#formEditUserData").removeClass("editMode")
					$("#ctnAjaxSuccess").html("").css("display", "none");
					$("#ctnAjaxError").html("").css("display", "none");
					$("#checkboxMarketing").attr("disabled", true)
				})

				$('#formEditUserData').submit(function(e){
					e.preventDefault();

					try {
						var l = {},
							propertyWanted = ["id_customer", "new_email", "current_email", "phone", "accepts_marketing"],
							propertyRequired = ["id_customer", "new_email", "current_email"],
							errors = [];

						$("#ctnAjaxSuccess").html("").css("display", "none");
						$("#ctnAjaxError").html("").css("display", "none");

						$($(this).serializeArray()).each(function(index, o) {
							if(propertyWanted.indexOf(o.name) !== -1)
								if(propertyRequired.indexOf(o.name) !== -1 && o.value != null || propertyRequired.indexOf(o.name) === -1)
									l[o.name] = o.value;
								else	errors.push("Please fill the field: "+o.name);
						})

						// console.info('ll', l);
						// return;
						
						if(errors.length > 0){
							$('#ctnAjaxError').html(errors.map(t => {
								return '<div>' + t + '</div>';
							}).join("")).css("display", "block");
						} else if(l.id_customer && errors.length === 0){

							$(".btnSubmitEditAccount").addClass("btn--loading").attr("disabled", true)

							req(Object.assign({
								"api": "shopify",
								"trigger": "updateAccount",
								"shop": 202487
							}, l), function(r){
								console.log("Result: ", r);
								$(".btnSubmitEditAccount").removeClass("btn--loading").attr("disabled", false)
								if(r.success){
									$('#ctnAjaxSuccess').html('Account updated').css("display", "block");
								}else
									$('#ctnAjaxError').html(r.errors.map(err => {
										return '<div>'+err+'</div>'
									}).join('')).css("display", "block"); // 'Something went wrong, please try again later or call/email us.'
							}, function(error){
								$(".btnSubmitEditAccount").removeClass("btn--loading").attr("disabled", false)
								alert(error);
							});
						}
					} catch (error) {
						console.warn(error);
					}
				})
			})(); */


		/* $('body').on('click', ".tag-list a", function(evt) {
			var $el = $(this);
			if (theme.FilterDrawer) {
			theme.FilterDrawer.close();
			}
	
			if ($el.hasClass('no-ajax')) {
			return;
			}
	
			evt.preventDefault();
			if (isAnimating) {
			return;
			}
	
			isAnimating = true;
	
			console.info("AAAAAAAAA");
			$('.tag-list a').each(function() {
				console.info("SSSSSSSS", this);
				var $el = $(this);
				var $parent = $el.parent();
				var newUrl = $el.attr('href');
		
				if (settings.combineTags) {
				if ($parent.hasClass('tag--active')) {
					$parent.removeClass('tag--active');
				} else {
					$parent.addClass('tag--active');
		
					// If adding a tag, show new tag right away.
					// Otherwise, remove it before ajax finishes
					if ($el.parent('li').hasClass('tag--remove')) {
					$(this).parent().remove();
					} else {
					$('.tag-list--active-tags').append('<li class="tag tag--remove"><a class="btn btn--small">' + $el.text() + '</a></li>');
					}
				}
				} else {
				$('.tag-list a').parent().removeClass('tag--active');
				$parent.addClass('tag--active');
				}
			});
	
			updateScroll(true);
	
			history.pushState({}, '', newUrl);
			$(selectors.collectionGrid).addClass('unload');
			getNewCollectionContent(newUrl);
		}); */

		
		/* $(".imgFlagEventError").on("error", function(e){
			this.style.display = 'none';
			//console.log(e);
			
			$(e.target).parents(".ctn_vendor_line_icon").removeClass('flexInBetween').addClass('flexCenter');
		})*/

		// Add the header at top of looxReviews when looxReviews is loaded
		// Do when looxReviews is loaded
		let intReview = setInterval(function(){
			if($('#looxReviews[data-upgraded="true"]').length > 0){
				$("#looxReviews").parents(".index-section").prepend(`<div class="page-width ctnLineSection {{class}}">
					<div class="titleSection">
						<span class="adjustingTitle">Reviews</span>
					</div>
					<div class="lineSplittingSection"></div>
				</div>`);
				clearInterval(intReview);
			}
		}, 100);

		/* let intOldTagSystem = setInterval(function(){
			if($(".tag__text__haus").length > 0){
				$(".tag__text__haus").each(function(i, node){
					$(node).children().addClass("tag__text"); // no-ajax
				})
				clearInterval(intOldTagSystem);
			}
		}, 100); */

		// RIDGID Giveaway Modal functionality
		function openRidgidGiveawayModal(collectionHandle) {
			// Initialize the modal if not already initialized
			if (!window.ridgidGiveawayModal) {
				window.ridgidGiveawayModal = new theme.Modals('RidgidGiveawayModal', 'ridgid-giveaway', {
					closeOffContentClick: true,
					solid: false
				});
				
				// Check if modal was successfully created (constructor returns false if element doesn't exist)
				if (window.ridgidGiveawayModal === false || !window.ridgidGiveawayModal || !window.ridgidGiveawayModal.modal) {
					console.warn('RidgidGiveawayModal element not found in DOM');
					window.ridgidGiveawayModal = null;
					return;
				}
			}
			
			// Safety check: ensure modal exists and is valid before proceeding
			if (window.ridgidGiveawayModal === false || !window.ridgidGiveawayModal || !window.ridgidGiveawayModal.modal) {
				console.warn('RidgidGiveawayModal is not available');
				return;
			}
			
			// Update modal links based on collection handle
			if (collectionHandle) {
				// Get the collection URL from Shopify's global collections object
				var collectionUrl = '/collections/' + collectionHandle;
				
				// Update all collection links in the modal
				$('#RidgidGiveawayModal .ridgid-collection-link').each(function() {
					$(this).attr('href', collectionUrl);
				});
			}
			
			// Open the modal
			window.ridgidGiveawayModal.open();
		}
		
		// Make function globally accessible
		window.openRidgidGiveawayModal = openRidgidGiveawayModal;

		// Promo Progress Bar functionality
		(function() {
			function updatePromoProgress() {
				if (!window.theme || !theme.cart || typeof theme.cart.getCart !== 'function') {
					return;
				}

				const promoZones = document.querySelectorAll('.promo-progress-zone');
				if (!promoZones.length) {
					return;
				}

				theme.cart.getCart().then(function(cart) {
					if (!cart || !Array.isArray(cart.items)) {
						return;
					}

					promoZones.forEach(function(zone) {
						const minQuantity = parseInt(zone.dataset.promoMinQuantity, 10) || 0;
						const productIdsStr = zone.dataset.promoProductIds || '';
						const discountPercentage = parseFloat(zone.dataset.promoDiscountPercentage) || 0;
						const productIds = productIdsStr.split(',').filter(function(id) {
							return id.trim() !== '';
						}).map(function(id) {
							return parseInt(id.trim(), 10);
						});

						if (minQuantity === 0 || productIds.length === 0) {
							return;
						}

						// Count qualifying items in cart
						let qualifyingCount = 0;
						cart.items.forEach(function(item) {
							const itemProductId = parseInt(item.product_id, 10);
							if (productIds.indexOf(itemProductId) !== -1) {
								qualifyingCount += item.quantity;
							}
						});

						// Update progress bar
						const progressFill = zone.querySelector('.promo-progress-fill');
						const currentCountEl = zone.querySelector('.promo-current-count');
						const itemsNeededEl = zone.querySelector('.promo-items-needed');
						const progressText = zone.querySelector('.promo-progress-text p');
						const progressCollections = zone.getAttribute('data-promo-collections-title');

						if (progressFill) {
							const progress = Math.min((qualifyingCount / minQuantity) * 100, 100);
							progressFill.style.width = progress + '%';
							
							// Add completed class if reached
							if (qualifyingCount >= minQuantity) {
								zone.classList.add('promo-progress-complete');
								progressFill.classList.add('promo-progress-fill-complete');
							} else {
								zone.classList.remove('promo-progress-complete');
								progressFill.classList.remove('promo-progress-fill-complete');
							}
						}

						if (currentCountEl) {
							currentCountEl.textContent = qualifyingCount;
						}

						/* if (itemsNeededEl) {
							const remaining = Math.max(minQuantity - qualifyingCount, 0);
							itemsNeededEl.textContent = remaining;
						} */

						if (progressText && qualifyingCount >= minQuantity) {
							// progressText.innerHTML = '<p><strong>' + discountPercentage + '%</strong> OFF '+minQuantity+' or more</p><p>'+progressCollections+'</p>';
						}
					});
				}).catch(function(error) {
					console.error('Error fetching cart for promo progress:', error);
				});
			}

			// Initialize on page load
			function initPromoProgress() {
				updatePromoProgress();
				
				// Listen for cart updates
				document.addEventListener('cart:updated', updatePromoProgress);
				document.addEventListener('ajaxProduct:added', updatePromoProgress);
				
				// Also check periodically in case events don't fire
				setInterval(updatePromoProgress, 2000);
			}

			// Wait for DOM and theme.cart to be ready
			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', function() {
					setTimeout(initPromoProgress, 500);
				});
			} else {
				setTimeout(initPromoProgress, 500);
			}
		})();
});

// Keep the mobile collection filter bar flush below the sticky header without
// covering the header or leaving a scroll gap above the filter row.
(function() {
	var mobileQuery = window.matchMedia('(max-width: 768px)');

	function syncCollectionFilterStickyTop() {
		if (!mobileQuery.matches) {
			document.documentElement.style.removeProperty('--collection-filter-sticky-top');
			return;
		}

		var top = 0;
		var stuckHeader = document.querySelector('.site-header--stuck');

		if (stuckHeader) {
			var headerWrap = document.getElementById('StickyHeaderWrap');
			top = headerWrap ? headerWrap.offsetHeight : stuckHeader.offsetHeight;
		}

		document.documentElement.style.setProperty('--collection-filter-sticky-top', top + 'px');
	}

	var syncScheduled = false;
	function scheduleSync() {
		if (syncScheduled) {
			return;
		}
		syncScheduled = true;
		window.requestAnimationFrame(function() {
			syncScheduled = false;
			syncCollectionFilterStickyTop();
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scheduleSync);
	} else {
		scheduleSync();
	}

	window.addEventListener('resize', scheduleSync);
	window.addEventListener('scroll', scheduleSync, { passive: true });
	mobileQuery.addEventListener('change', scheduleSync);
})();

/* var selectors = {
	collectionGrid: '.collection-grid__wrapper',
	sidebar: '#CollectionSidebar',
	activeTagList: '.tag-list--active-tags',
	tags: '.tag-list a',
	filters: '.collection-filter'
};
var classes = {
	activeTag: 'tag--active',
	removeTagParent: 'tag--remove'
};

function initTagClicks() {
	$('body').on('click', selectors.tags, function(evt) {
		var $el = $(this);
		// if (theme.FilterDrawer) {
		// 	theme.FilterDrawer.close();
		// }

		if ($el.hasClass('no-ajax')) {
			return;
		}

		evt.preventDefault();
		if (isAnimating) {
			return;
		}

		isAnimating = true;

		var $el = $(evt.currentTarget);
		var $parent = $el.parent();
		var newUrl = $el.attr('href');

		if (settings.combineTags) {
			if ($parent.hasClass(classes.activeTag)) {
				$parent.removeClass(classes.activeTag);
			} else {
				$parent.addClass(classes.activeTag);

				// If adding a tag, show new tag right away.
				// Otherwise, remove it before ajax finishes
				if ($el.parent('li').hasClass(classes.removeTagParent)) {
					$(this).parent().remove();
				} else {
					$(selectors.activeTagList).append('<li class="tag tag--remove"><a class="btn btn--small">' + $el.text() + '</a></li>');
				}
			}
		} else {
			$(selectors.tags).parent().removeClass(classes.activeTag);
			$parent.addClass(classes.activeTag);
		}

		updateScroll(true);
	});
}

function updateScroll(animate) {
	var scrollTo;

	scrollTo = $('.collection-filter').offset().top + 1;

	if (animate) {
		$('html, body').animate({ scrollTop: scrollTo }, 300);
	} else {
		$('html, body').scrollTop(scrollTo);
	}
} */